// Le canal « À TerObs » (fiche I, 06/10) : posé par `ObsLayout` pour un compte qui voit la
// commune EN ABONNÉ (abonné ou essai), hors équipe TerObs, drapeau allumé (`/meta` →
// `features.commentaires_terobs`). Les sections et la synthèse y ajoutent leur ancre ; le
// panneau « Comprendre ce chiffre » propose « Écrire à TerObs » seulement s'il trouve un canal
// ET une ancre. Sinon — visiteur, compte gratuit, carte, page partagée — il garde `/contact`.
// Le serveur revérifie tout : ce contexte ne fait qu'éviter de montrer un bouton inutile.
import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

export interface CanalTerObs {
  insee: string
  token: string | null
  page?: string
  section?: string
  /** Membre OFFICIEL de l'espace de la commune (`viewer.commune_role` servi par `/meta`) : le
      niveau « Mon équipe » lui est proposé (#563). Le serveur le revérifie à chaque écriture. */
  membre?: boolean
  /** Écrire de nouveaux messages (abonné ou essai). Faux : un membre dont l'abonnement a pris
      fin relit ses fils, sans bulle « Commenter » ni « Écrire à TerObs » (CDC I, I-A12).
      Absent : vrai (canal posé avant #563). */
  ecriture?: boolean
}

export const CanalTerObsCtx = createContext<CanalTerObs | null>(null)

export const useCanalTerObs = () => useContext(CanalTerObsCtx)

/** Ajoute l'ancre (page ou section) au canal du parent ; sans canal, ne fait rien. */
export function AncreTerObs({ page, section, children }:
                            { page?: string; section?: string; children: ReactNode }) {
  const parent = useCanalTerObs()
  if (!parent) return <>{children}</>
  return (
    <CanalTerObsCtx.Provider value={{ ...parent, ...(page ? { page } : {}), ...(section ? { section } : {}) }}>
      {children}
    </CanalTerObsCtx.Provider>
  )
}
